import { useState } from 'react';
import DB from '../data/mockData';

const DEPT_LABELS = {
  BD: { cls: 'dep-bd', ico: '💼', label: 'BD' },
  Comm: { cls: 'dep-cm', ico: '📊', label: 'Comm' },
  Legal: { cls: 'dep-lg', ico: '⚖️', label: 'Legal' },
  RA: { cls: 'dep-ra', ico: '🔬', label: 'RA' },
  MD: { cls: 'dep-md', ico: '🏛', label: 'MD' },
};

const STAGE_CFG = {
  Assess:    { pill: 'p-g', ico: '✓' },
  Negotiate: { pill: 'p-t', ico: '🤝' },
  Portfolio: { pill: 'p-o', ico: '🏛' },
  Complete:  { pill: 'p-n', ico: '📝' },
};

const STATUS_PILL = {
  'Awaiting MD':   'p-a',
  'In progress':   'p-t',
  'Active':        'p-g',
  'In committee':  'p-t',
  'Review needed': 'p-r',
};

const WF_STAGES = [
  { key: 'Assess', ico: '✓', state: 'done' },
  { key: 'Negotiate', ico: '🤝', state: 'active' },
  { key: 'Portfolio', ico: '🏛', state: 'gold' },
  { key: 'Complete', ico: '📝', state: 'pending' },
  { key: 'Handover', ico: '🤲', state: 'pending' },
  { key: 'Launch', ico: '🚀', state: 'pending' },
];

export default function Pipeline() {
  const [filter, setFilter] = useState('');
  const filtered = filter ? DB.pipeline.filter(p => p.stage === filter) : DB.pipeline;

  const counts = {};
  DB.pipeline.forEach(p => { counts[p.stage] = (counts[p.stage] || 0) + 1; });

  return (
    <div className="content">
      {/* Banner */}
      <div className="d-flex align-items-center gap-3 p-3 rounded-4 flex-wrap" style={{ background: 'linear-gradient(135deg,#0c2f45,#1a5e7d)' }}>
        <div className="fo-banner-ico">🔄</div>
        <div className="flex-grow-1 text-white" style={{ fontSize: '12.5px', lineHeight: 1.5, opacity: .92 }}>
          <strong style={{ color: '#7DD6F0' }}>Cross-department in-licensing pipeline.</strong> BD initiates · Commercial prices · Legal reviews · RA registers · MD approves Portfolio entry.
        </div>
        <button className="btn btn-s btn-sm" style={{ background: 'rgba(255,255,255,.12)', border: '1px solid rgba(255,255,255,.2)', color: '#fff' }}>+ New Project</button>
      </div>

      {/* Workflow stages */}
      <div className="card">
        <div className="ch">
          <div className="ch-ico">🔄</div>
          <div><div className="ch-title">Pipeline Overview</div><div className="ch-sub">{DB.pipeline.length} active projects across 6 stages</div></div>
          <div className="ch-act ms-auto"><span className="ai-badge">✦ Nova tracking</span></div>
        </div>
        <div className="cb">
          <div className="d-flex align-items-center justify-content-between overflow-auto gap-0" style={{ maxWidth: 680 }}>
            {WF_STAGES.map((wf, i) => {
              const cnt = counts[wf.key] || 0;
              const stateColors = {
                done: { border: 'var(--green)', bg: 'var(--green2)', lblColor: 'var(--green)' },
                active: { border: 'var(--teal)', bg: 'var(--teal3)', lblColor: 'var(--teal)' },
                gold: { border: 'var(--gold)', bg: 'var(--gold2)', lblColor: 'var(--gold)' },
                pending: { border: 'var(--brd)', bg: 'var(--card)', lblColor: 'var(--t3)' },
              }[wf.state];
              return (
                <div key={wf.key} className="d-flex align-items-center">
                  {i > 0 && <div style={{ width: 26, height: 2, background: wf.state === 'pending' ? 'var(--brd)' : stateColors.border, marginTop: -23, flexShrink: 0 }} />}
                  <div className="d-flex flex-column align-items-center gap-1 flex-shrink-0" style={{ cursor: 'pointer', opacity: wf.state === 'pending' ? .45 : 1 }} onClick={() => setFilter(filter === wf.key ? '' : wf.key)}>
                    <div className="d-flex align-items-center justify-content-center rounded-circle" style={{ width: 46, height: 46, border: `2.5px solid ${stateColors.border}`, background: stateColors.bg, fontSize: 17 }}>
                      {wf.state === 'done' ? '✓' : wf.ico}
                    </div>
                    <div style={{ fontSize: 9, fontWeight: 700, color: stateColors.lblColor, textAlign: 'center', textTransform: 'uppercase', letterSpacing: '.3px', maxWidth: 58 }}>
                      {wf.key}<br /><strong style={{ fontSize: 11 }}>{cnt}{wf.key === 'Portfolio' ? ' ⚡' : ''}</strong>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Department tags */}
      <div className="card" style={{ background: 'linear-gradient(135deg,#F5FAFE,#EBF5FB)' }}>
        <div className="cb py-2 d-flex align-items-center gap-2 flex-wrap">
          <span style={{ fontSize: 10, fontWeight: 700, color: 'var(--t3)', textTransform: 'uppercase', letterSpacing: '.5px' }}>Teams:</span>
          {Object.values(DEPT_LABELS).map((d, i) => (
            <span key={i} className={`dep ${d.cls}`}>{d.ico} {d.label === 'BD' ? 'Business Dev' : d.label === 'Comm' ? 'Commercial' : d.label === 'Legal' ? 'Legal' : d.label === 'RA' ? 'Regulatory Affairs' : 'Managing Director'}</span>
          ))}
        </div>
      </div>

      {/* Projects table */}
      <div className="card">
        <div className="ch">
          <div className="ch-ico">📋</div>
          <div><div className="ch-title">All Projects</div><div className="ch-sub">{filter ? `Showing: ${filter}` : 'Showing all stages'}</div></div>
          <div className="ch-act ms-auto d-flex gap-2">
            <select className="finput" style={{ width: 'auto', fontSize: 12, padding: '6px 10px' }} value={filter} onChange={e => setFilter(e.target.value)}>
              <option value="">All Stages</option><option>Assess</option><option>Negotiate</option><option>Portfolio</option><option>Complete</option>
            </select>
            <button className="btn btn-s btn-sm">Export</button>
          </div>
        </div>
        <div className="table-responsive">
          <table className="tbl">
            <thead>
              <tr>
                <th>Product</th>
                <th className="d-none d-sm-table-cell">Supplier</th>
                <th>Stage</th>
                <th className="d-none d-lg-table-cell">Departments</th>
                <th className="d-none d-md-table-cell">Est. Revenue</th>
                <th className="d-none d-md-table-cell">Days</th>
                <th className="d-none d-lg-table-cell">Next Action</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(p => {
                const scfg = STAGE_CFG[p.stage] || { pill: 'p-n', ico: '' };
                return (
                  <tr key={p.id} style={p.highlight ? { background: 'rgba(154,116,0,.04)' } : {}}>
                    <td>
                      <strong>{p.product}</strong>
                      {p.highlight && <div style={{ fontSize: 10, color: 'var(--amber)' }}>⚡ Approval needed</div>}
                    </td>
                    <td className="d-none d-sm-table-cell" style={{ fontSize: 12 }}>{p.supplier}</td>
                    <td><span className={`pill ${scfg.pill}`}>{scfg.ico} {p.stage}</span></td>
                    <td className="d-none d-lg-table-cell">
                      <div className="d-flex flex-wrap gap-1">
                        {p.depts.map((d, i) => {
                          const dl = DEPT_LABELS[d];
                          return dl ? <span key={i} className={`dep ${dl.cls}`}>{dl.ico} {dl.label}</span> : <span key={i}>{d}</span>;
                        })}
                      </div>
                    </td>
                    <td className="d-none d-md-table-cell" style={{ fontWeight: 700, color: p.revenue !== 'TBD' ? 'var(--green)' : 'var(--t3)' }}>{p.revenue}</td>
                    <td className="d-none d-md-table-cell" style={{ fontFamily: "'DM Mono'", fontSize: 12 }}>{p.days}d</td>
                    <td className="d-none d-lg-table-cell" style={{ fontSize: '11.5px', color: p.highlight ? 'var(--amber)' : 'var(--t2)' }}>{p.nextAction}</td>
                    <td><span className={`pill ${STATUS_PILL[p.status] || 'p-n'}`}>{p.status}</span></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* Bottom stats row */}
      <div className="row g-3">
        <div className="col-md-4">
          <div className="card">
            <div className="ch"><div className="ch-ico">📉</div><div><div className="ch-title">Funnel Rates</div><div className="ch-sub">AI-tracked success</div></div></div>
            <div className="cb d-flex flex-column gap-2">
              {[{ label: 'Assess→Negotiate', pct: 72, cls: 'bg-success' }, { label: 'Negotiate→Portfolio', pct: 58, cls: 'bg-warning' }, { label: 'Portfolio→Launch', pct: 41, cls: 'bg-danger' }].map((f, i) => (
                <div key={i} className="d-flex align-items-center gap-2">
                  <span style={{ fontSize: '11.5px', minWidth: 130 }}>{f.label}</span>
                  <div className="progress flex-grow-1" style={{ height: 4 }}><div className={`progress-bar ${f.cls}`} style={{ width: `${f.pct}%` }} /></div>
                  <span style={{ fontSize: 11, fontFamily: "'DM Mono'", color: 'var(--t3)' }}>{f.pct}%</span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card">
            <div className="ch"><div className="ch-ico">⏱</div><div><div className="ch-title">Avg Lead Time</div></div></div>
            <div className="cb d-flex flex-column gap-2">
              {[{ label: 'Assess', val: '14d', pct: 18, cls: '' }, { label: 'Negotiate', val: '45d', pct: 55, cls: 'bg-warning' }, { label: 'Portfolio→Launch', val: '180d', pct: 88, cls: 'bg-danger' }].map((f, i) => (
                <div key={i} className="d-flex align-items-center gap-2">
                  <span style={{ fontSize: '11.5px', minWidth: 130 }}>{f.label}</span>
                  <div className="progress flex-grow-1" style={{ height: 4 }}><div className={`progress-bar ${f.cls}`} style={{ width: `${f.pct}%` }} /></div>
                  <span style={{ fontSize: 11, fontFamily: "'DM Mono'", color: 'var(--t3)' }}>{f.val}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card">
            <div className="ch"><div className="ch-ico">👥</div><div><div className="ch-title">Dept Workload</div></div></div>
            <div className="cb d-flex flex-column gap-2">
              {[
                { dep: 'dep-bd', ico: '💼', label: 'BD', tasks: 5, pill: 'p-g', status: 'On track' },
                { dep: 'dep-cm', ico: '📊', label: 'Commercial', tasks: 3, pill: 'p-g', status: 'On track' },
                { dep: 'dep-lg', ico: '⚖️', label: 'Legal', tasks: 2, pill: 'p-a', status: '1 overdue' },
                { dep: 'dep-ra', ico: '🔬', label: 'RA', tasks: 4, pill: 'p-g', status: 'On track' },
              ].map((w, i) => (
                <div key={i} className="d-flex align-items-center gap-2 justify-content-between">
                  <span className={`dep ${w.dep}`}>{w.ico} {w.label}</span>
                  <strong>{w.tasks} tasks</strong>
                  <span className={`pill ${w.pill}`}>{w.status}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
